import { FormControl, Validators, ValidatorFn } from '@angular/forms';

export class CoreValidators {
	private static readonly EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
	// private static readonly BANK_ACCOUNT_REGEXP = /^(0*([1-9]\d{0,5})-)?0*([1-9]\d{0,9})$/i;
	private static readonly BANK_ACCOUNT_REGEXP = /^(\d{1,6}\-)?\d{2,10}\/\d{4}$/i;
	private static readonly IBAN_REGEXP = /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$/i;

	public static validateEmail(control: FormControl): { [key: string]: any } {
		return CoreValidators.EMAIL_REGEXP.test(control.value) ? null : {
			validateEmail: {
				valid: false
			}
		};
	}

	public static validateNumber(args?: NumberValidatorArgs): ValidatorFn {
		return (control: FormControl): { [key: string]: any } => {
			if (Validators.required(control) != null) {
				return null;
			}

			let val: number = control.value;
			let regexp: RegExp;

			if (isNaN(val) || (args.float != true && /\D/.test(val.toString()))) {
				return { 'number': true };
			}

			if (args) {
				let result = { 'number': { 'min': args.min, 'max': args.max, 'value': val } };

				if (!isNaN(args.min) && !isNaN(args.max)) {
					return val < args.min || val > args.max ? result : null;
				} else if (!isNaN(args.min)) {
					return val < args.min ? result : null;
				} else if (!isNaN(args.max)) {
					return val > args.max ? result : null;
				}
			}

			return null;
		};
	}

	public static validateBankAccount(control: FormControl): { [key: string]: any } {
		let v = control.value || '';
		if (v.length < 1) {
			return null;
		}

		return CoreValidators.BANK_ACCOUNT_REGEXP.test(control.value) ? null : {
			validateBankCode: {
				valid: false
			}
		};
	}

	public static validateIBAN(control: FormControl): { [key: string]: any } {
		let v = control.value || '';
		if (v.length < 1) {
			return null;
		}

		return CoreValidators.IBAN_REGEXP.test(control.value) ? null : {
			validateIBAN: {
				valid: false
			}
		};
	}

	public static validateAuctionPrices(c: FormControl) {
		// safety check
		if (!c.get('startingPrice').value || !c.get('buyNowPrice').value || !c.get('buyNowEnabled').value) {
			return null;
		}

		if (c.get('startingPrice').value > c.get('buyNowPrice').value) {
			return {
				validateAuctionPrices: {
					valid: false
				}
			};
		}
		return null;
	}

	public static validateWordsLength(c: FormControl) {
		let v = c.value || '';
		if (v.length < 30) { // max word length limit
			return null;
		}

		let words = v.split(' ');
		return words.filter(x => x.length > 30).length < 1 ? null : {
			validateWordsLength: {
				valid: false
			}
		};
	}
}

interface NumberValidatorArgs {
	min?: number;
	max?: number;
	float?: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/validators.ts